export const PLAN_WEEKLY = 'weekly';
export const PLAN_FORTNIGHTLY = 'fortnightly';
export const PLAN_MONTHLY = 'monthly';
export const PLANS_ALLOWED = [
    PLAN_WEEKLY,
    PLAN_FORTNIGHTLY,
    PLAN_MONTHLY,
];

export const GIFT_TYPE_SUBSCRIPTION = 'subscription';
export const GIFT_TYPE_ONE_OFF = 'one-off';

export const SECTION_CHOOSE_A_GIFT = 'chooseAGift';
export const PRODUCT_TYPE_SINGLE = 'oneDelivery';
export const PRODUCT_TYPE_MULTI = 'multipleDeliveries';
export const SECTION_NUMBER_OF_DELIVERIES = 'numberOfDeliveries';
export const SECTION_DELIVERY_ADDRESS = 'deliveryAddress';
export const SECTION_FREDDIES_ADDONS = 'freddiesAddons';
export const SECTION_FREDDIES_SHOP = 'freddiesShop';
export const SECTION_DELIVERY_DATE = 'deliveryDate';
export const SECTION_GIFT_CARD = 'giftCardCompleted';
